import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PropertyService } from '@smartflip/helper-utils';
import { AsyncPipe, CurrencyPipe, NgClass } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RoiService } from '../../../../../services/ui-utils/src/lib/roi.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'lib-property-financial-summary',
  imports: [AsyncPipe, CurrencyPipe, NgClass, IonicModule],
  templateUrl: './PropertyFinancialSummary.component.html',
  styleUrl: './PropertyFinancialSummary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyFinancialSummaryComponent {
  public sellingPrice = 0;
  public purchasePrice = 0;
  public estimatedProfit$ = new BehaviorSubject<number>(0);
  public profitText = '';
  public sellingText = '';
  public purchaseText = '';

  constructor(
    private propertyService: PropertyService,
    private roiService: RoiService,
  ) {
    const currentProperty = this.propertyService.currentProperty;

    this.sellingPrice = currentProperty?.summary?.sell || 0;
    this.purchasePrice = currentProperty?.summary?.price || 0;
    this.sellingText = currentProperty?.gen?.solddate ? '' : ' (Estimated)';
    this.purchaseText = currentProperty?.gen?.purchasedate
      ? ''
      : ' (Estimated)';
    this.profitText = this.sellingText; // Profit is also estimated if selling price is estimated
    this.roiService.calculationValues$.subscribe((calculation) => {
      this.estimatedProfit$.next(calculation.profit || 0);
    });
  }
}
